import React, { useState } from 'react'
import IInvoiceDocument from 'interfaces/service/Invoice/IInvoiceDocument'
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import LoadingSpinnerAlt from 'Components/LoadingSpinnerAlt';
import InvoicesListContext from './InvoicesListContext';
import { Link } from 'react-router-dom';
import { INVOICES_EDIT, WITHHOLDINGS_LIST } from 'Constants/Routes';
import uiStore from 'stores/uiStore';

type ActionButtonsProps = {
    invoice: IInvoiceDocument,
}

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'

export function isInvoiceLinkedToWithholding(invoice: IInvoiceDocument) {
    if (invoice.HasWithholding === true) return true
    const id = invoice.IdWithholding
    if (id == null || id === '' || id === EMPTY_GUID) return false
    return true
}

const ActionButtons = ({ invoice }: ActionButtonsProps) => {
    const { t } = useTranslation();
    const [isDeleting, setisDeleting] = useState(false)
    const { deleteInvoice } = React.useContext(InvoicesListContext)
    const linked = isInvoiceLinkedToWithholding(invoice)

    async function handleDelete() {
        if (linked) {
            uiStore.notifyWarning(t('this_invoice_is_part_of_a_withholding_and_cannot_be_deleted'))
            return
        }
        const confirmation = await uiStore.confirm({
            title: t('confirm_delete_title'),
            message: t('confirm_deletion'),
            confirmLabel: t('delete'),
            cancelLabel: t('cancel'),
            variant: 'danger',
        })
        if (!confirmation) return
        try {
            setisDeleting(true)
            await deleteInvoice(invoice)
        } finally {
            setisDeleting(false)
        }
    }

    if (linked) {
        return (
            <span className="invoice-action-buttons">
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id={`view-withholding-${invoice.Id}`}>
                            {t('go_to_withholding', { defaultValue: 'Ver retención asociada' })}
                        </Tooltip>
                    }
                >
                    <Link
                        to={`${WITHHOLDINGS_LIST}?id=${encodeURIComponent(invoice.IdWithholding)}`}
                        className="mx-2 text-info"
                        aria-label={t('go_to_withholding', { defaultValue: 'Ver retención asociada' })}
                    >
                        <i className="fas fa-file-invoice-dollar" />
                    </Link>
                </OverlayTrigger>
            </span>
        )
    }

    return (
        <span className="invoice-action-buttons">
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id={`edit-${invoice.Id}`}>
                        {t('edit')}
                    </Tooltip>
                }
            >
                <Link
                    to={INVOICES_EDIT.replace(':id', invoice.Id)}
                    className="mx-2 text-primary"
                    aria-label={t('edit')}
                >
                    <i className="fas fa-edit" />
                </Link>
            </OverlayTrigger>
            {isDeleting && (
                <div className="d-inline-block action-button-loading-container">
                    <LoadingSpinnerAlt />
                </div>
            )}
            {!isDeleting && (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id={`delete-${invoice.Id}`}>
                            {t('delete')}
                        </Tooltip>
                    }
                >
                    <button
                        type="button"
                        className="btn btn-link text-danger p-0 mx-2"
                        onClick={handleDelete}
                        aria-label={t('delete')}
                    >
                        <i className="fas fa-trash" />
                    </button>
                </OverlayTrigger>
            )}
        </span>
    )
}

export default ActionButtons
